// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#datatable span {
  font-size: 1.2rem;
}
#datatable .div-picture {
  position: relative;
  text-align: center;
}
#datatable .div-picture .avatar {
  width: 64px;
  height: 64px;
}
#datatable .div-picture .element {
  position: absolute;
  border-radius: 50px;
  width: 15px;
  height: 15px;
  top: 3px;
  left: 3px;
}
#datatable .div-picture .rouge {
  background-color: #d33630;
}
#datatable .div-picture .vert {
  background-color: #65b045;
}

.div-filter {
  margin-bottom: 15px;
  margin-left: 50px;
}
.div-filter .input-filter {
  margin-left: 15px;
  height: 65px;
  width: 170px;
}

.button2 {
  background-color: #e9af51;
  border: none;
  color: white;
  padding: 0px 5px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  margin-right: 15px;
}

.material {
  box-shadow: none;
}

.date-archived {
  text-transform: capitalize;
}

::ng-deep .myTooltip .mdc-tooltip__surface {
  background: #ecac54 !important;
  font-size: 1rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+trashcan/see-trashcan/see-trashcan.component.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAGE;EACE,iBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,kBAAA;AAHJ;AAKI;EACE,WAAA;EACA,YAAA;AAHN;AAMI;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;AAJN;AAOI;EACE,yBAAA;AALN;AAQI;EACE,yBAAA;AANN;;AAWA;EACE,mBAAA;EACA,iBAAA;AARF;AAUE;EACE,iBAAA;EACA,YAAA;EACA,YAAA;AARJ;;AAYA;EACE,yBCxCgB;EDyChB,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AATF;;AAYA;EACE,gBAAA;AATF;;AAYA;EACE,0BAAA;AATF;;AAYE;EACE,8BAAA;EACA,0BAAA;AATJ","sourcesContent":["@import \"/src/styles/_variables.scss\";\r\n\r\n#datatable {\r\n  span {\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  .div-picture {\r\n    position: relative;\r\n    text-align: center;\r\n\r\n    .avatar {\r\n      width: 64px;\r\n      height: 64px;\r\n    }\r\n\r\n    .element {\r\n      position: absolute;\r\n      border-radius: 50px;\r\n      width: 15px;\r\n      height: 15px;\r\n      top: 3px;\r\n      left: 3px;\r\n    }\r\n\r\n    .rouge {\r\n      background-color: #d33630;\r\n    }\r\n\r\n    .vert {\r\n      background-color: #65b045;\r\n    }\r\n  }\r\n}\r\n\r\n.div-filter {\r\n  margin-bottom: 15px;\r\n  margin-left: 50px;\r\n\r\n  .input-filter {\r\n    margin-left: 15px;\r\n    height: 65px;\r\n    width: 170px;\r\n  }\r\n}\r\n\r\n.button2 {\r\n  background-color: $secondary-color;\r\n  border: none;\r\n  color: white;\r\n  padding: 0px 5px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-size: 16px;\r\n  margin: 4px 2px;\r\n  cursor: pointer;\r\n  margin-right: 15px;\r\n}\r\n\r\n.material {\r\n  box-shadow: none;\r\n}\r\n\r\n.date-archived {\r\n  text-transform: capitalize;\r\n}\r\n::ng-deep .myTooltip {\r\n  .mdc-tooltip__surface {\r\n    background: #ecac54 !important;\r\n    font-size: 1rem !important;\r\n  }\r\n}\r\n","// Général\r\n$content-background-color: white;\r\n$primary-color: #104a64;\r\n$success-color: #badbcc;\r\n$success-text-color: #0f5132;\r\n$error-color: #f5c2c7;\r\n$error-text-color: #842029;\r\n$secondary-color: #e9af51;\r\n$secondary-color-light: #e9af51a1;\r\n$danger-color: rgb(255, 79, 79);\r\n$page-title-size: 2.3rem;\r\n$common-size: 1.05rem;\r\n$background-light: #104a64;\r\n\r\n// Header\r\n$width-logo: 145px;\r\n$filter-logo: brightness(0) invert(1);\r\n$header-height: 70px;\r\n$header-color-bottom-border: #cbd3db;\r\n\r\n// Left menu\r\n$left-menu-text-color: white;\r\n\r\n// GED\r\n$ged-background-hover-color: #e9af5128;\r\n$ged-folder-color: $primary-color;\r\n$ged-file-color: $primary-color;\r\n$ged-folder-color-hover: #0056b3;\r\n$ged-file-color-hover: #0056b3;\r\n\r\n// Data Tree\r\n$data-tree-left-menu-width: 300px;\r\n$data-tree-article-title-font-size: 2.8rem;\r\n$data-tree-highlight-color: $secondary-color;\r\n\r\n// See rooms\r\n$see-rooms-title-size: 1.7rem;\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
